import { GoogleOutlined } from '@ant-design/icons'
import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderGoogleSheetCommon } from '../common'
import { FormConnectSteps } from './FormConnectSteps'
import { FormSetupSteps } from './FormSetupSteps'

export const ProviderGoogleSheetClient: ProviderClient = {
  key: ProviderGoogleSheetCommon.key,
  authentication: ProviderAuthenticationClient.Oauth2({
    ...ProviderGoogleSheetCommon.authentication,
    clientId: ProviderHelperClient.getEnvVariable('google', 'CLIENT_ID'),
  }),
  description: {
    label: 'Google Sheet',
    icon: <GoogleOutlined />,
    triggers: [],
    actions: [
      {
        key: 'findOneSpreadsheet',
        label: 'Read a spreadsheet',
        input: [{ key: 'spreadsheetId' }],
        output: [
          {
            key: 'sheets',
            type: 'array_objects',
            properties: [
              {
                key: 'properties',
                type: 'object',
                properties: [
                  {
                    key: 'title',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'findManySpreadsheets',
        label: 'List spreadsheets',
        input: [],
        output: [
          {
            key: 'sheets',
            type: 'array_objects',
            properties: [
              {
                key: 'properties',
                type: 'object',
                properties: [
                  {
                    key: 'id',
                  },
                  {
                    key: 'name',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  FormSetupSteps,
  FormConnectSteps,
}
